export default __webpack_public_path__ + "static/media/icBack.6c5af0a2.svg";